import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/laboratorial_analysis/:id',
  title: 'Editar Análise Laboratorial',
  endpoint: '/app/laboratory_analysis',
}
